import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Help, ArrowDownward } from '@mui/icons-material';

interface IPropsHelper {

}


// @observer
export default class Helper extends React.Component<IPropsHelper> {

    abrirJanela = () => {
        window.open('https://portalextranet.tst.jus.br/web/sistemas-satelites-do-pje-tst/gabinete-eletronico');
    }

    render() {
        return (
            <Tooltip title='Manuais do Gabinete Eletrônico'>
                <div>
                    <IconButton onClick={this.abrirJanela} aria-label='Link para os manuais do Gabinete Eletrônico. Irá abrir em uma nova janela.'>
                        <Help style={{ color: 'white' }} />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}
